// Generated by Melange

import * as Caml_module from "melange.js/caml_module.js";
import * as Ocaml_protoc_plugin__Result from "../../../vendored/ocaml_protoc_plugin/result.js";

const Imported$pmodules = {};

const Buhta = Caml_module.init_mod([
  "proto/documentapis/gen/buhta_document_v1_document_participant_sign_status.ml",
  56,
  6
], {
  TAG: /* Module */ 0,
  _0: [[
      {
        TAG: /* Module */ 0,
        _0: [[
            {
              TAG: /* Module */ 0,
              _0: [[
                  {
                    TAG: /* Module */ 0,
                    _0: [
                      [
                        /* Function */ 0,
                        "name"
                      ],
                      [
                        /* Function */ 0,
                        "to_int"
                      ],
                      [
                        /* Function */ 0,
                        "from_int"
                      ],
                      [
                        /* Function */ 0,
                        "from_int_exn"
                      ],
                      [
                        /* Function */ 0,
                        "to_string"
                      ],
                      [
                        /* Function */ 0,
                        "from_string_exn"
                      ]
                    ]
                  },
                  "DocumentParticipantSignStatus"
                ]]
            },
            "V1"
          ]]
      },
      "$$Document"
    ]]
});

const $$Document = Caml_module.init_mod([
  "proto/documentapis/gen/buhta_document_v1_document_participant_sign_status.ml",
  77,
  8
], {
  TAG: /* Module */ 0,
  _0: [[
      {
        TAG: /* Module */ 0,
        _0: [[
            {
              TAG: /* Module */ 0,
              _0: [
                [
                  /* Function */ 0,
                  "name"
                ],
                [
                  /* Function */ 0,
                  "to_int"
                ],
                [
                  /* Function */ 0,
                  "from_int"
                ],
                [
                  /* Function */ 0,
                  "from_int_exn"
                ],
                [
                  /* Function */ 0,
                  "to_string"
                ],
                [
                  /* Function */ 0,
                  "from_string_exn"
                ]
              ]
            },
            "DocumentParticipantSignStatus"
          ]]
      },
      "V1"
    ]]
});

const V1 = Caml_module.init_mod([
  "proto/documentapis/gen/buhta_document_v1_document_participant_sign_status.ml",
  96,
  10
], {
  TAG: /* Module */ 0,
  _0: [[
      {
        TAG: /* Module */ 0,
        _0: [
          [
            /* Function */ 0,
            "name"
          ],
          [
            /* Function */ 0,
            "to_int"
          ],
          [
            /* Function */ 0,
            "from_int"
          ],
          [
            /* Function */ 0,
            "from_int_exn"
          ],
          [
            /* Function */ 0,
            "to_string"
          ],
          [
            /* Function */ 0,
            "from_string_exn"
          ]
        ]
      },
      "DocumentParticipantSignStatus"
    ]]
});

const DocumentParticipantSignStatus = Caml_module.init_mod([
  "proto/documentapis/gen/buhta_document_v1_document_participant_sign_status.ml",
  113,
  12
], {
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "to_int"
    ],
    [
      /* Function */ 0,
      "from_int"
    ],
    [
      /* Function */ 0,
      "from_int_exn"
    ],
    [
      /* Function */ 0,
      "to_string"
    ],
    [
      /* Function */ 0,
      "from_string_exn"
    ]
  ]
});

function name(param) {
  return ".buhta.document.v1.DocumentParticipantSignStatus";
}

function to_int(param) {
  switch (param) {
    case /* DOCUMENT_PARTICIPANT_SIGN_STATUS_UNSPECIFIED */ 0 :
      return 0;
    case /* DOCUMENT_PARTICIPANT_SIGN_STATUS_PENDING */ 1 :
      return 10;
    case /* DOCUMENT_PARTICIPANT_SIGN_STATUS_SIGNED */ 2 :
      return 20;
  }
}

function from_int_exn(n) {
  if (n !== 0) {
    if (n !== 10) {
      if (n !== 20) {
        return Ocaml_protoc_plugin__Result.raise({
          NAME: "Unknown_enum_value",
          VAL: n
        });
      } else {
        return /* DOCUMENT_PARTICIPANT_SIGN_STATUS_SIGNED */ 2;
      }
    } else {
      return /* DOCUMENT_PARTICIPANT_SIGN_STATUS_PENDING */ 1;
    }
  } else {
    return /* DOCUMENT_PARTICIPANT_SIGN_STATUS_UNSPECIFIED */ 0;
  }
}

function from_int(e) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return from_int_exn(e);
  });
}

function to_string(param) {
  switch (param) {
    case /* DOCUMENT_PARTICIPANT_SIGN_STATUS_UNSPECIFIED */ 0 :
      return "DOCUMENT_PARTICIPANT_SIGN_STATUS_UNSPECIFIED";
    case /* DOCUMENT_PARTICIPANT_SIGN_STATUS_PENDING */ 1 :
      return "DOCUMENT_PARTICIPANT_SIGN_STATUS_PENDING";
    case /* DOCUMENT_PARTICIPANT_SIGN_STATUS_SIGNED */ 2 :
      return "DOCUMENT_PARTICIPANT_SIGN_STATUS_SIGNED";
  }
}

function from_string_exn(s) {
  switch (s) {
    case "DOCUMENT_PARTICIPANT_SIGN_STATUS_PENDING" :
      return /* DOCUMENT_PARTICIPANT_SIGN_STATUS_PENDING */ 1;
    case "DOCUMENT_PARTICIPANT_SIGN_STATUS_SIGNED" :
      return /* DOCUMENT_PARTICIPANT_SIGN_STATUS_SIGNED */ 2;
    case "DOCUMENT_PARTICIPANT_SIGN_STATUS_UNSPECIFIED" :
      return /* DOCUMENT_PARTICIPANT_SIGN_STATUS_UNSPECIFIED */ 0;
    default:
      return Ocaml_protoc_plugin__Result.raise({
        NAME: "Unknown_enum_name",
        VAL: s
      });
  }
}

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "to_int"
    ],
    [
      /* Function */ 0,
      "from_int"
    ],
    [
      /* Function */ 0,
      "from_int_exn"
    ],
    [
      /* Function */ 0,
      "to_string"
    ],
    [
      /* Function */ 0,
      "from_string_exn"
    ]
  ]
}, DocumentParticipantSignStatus, {
  name: name,
  to_int: to_int,
  from_int: from_int,
  from_int_exn: from_int_exn,
  to_string: to_string,
  from_string_exn: from_string_exn
});

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [[
      {
        TAG: /* Module */ 0,
        _0: [
          [
            /* Function */ 0,
            "name"
          ],
          [
            /* Function */ 0,
            "to_int"
          ],
          [
            /* Function */ 0,
            "from_int"
          ],
          [
            /* Function */ 0,
            "from_int_exn"
          ],
          [
            /* Function */ 0,
            "to_string"
          ],
          [
            /* Function */ 0,
            "from_string_exn"
          ]
        ]
      },
      "DocumentParticipantSignStatus"
    ]]
}, V1, {
  DocumentParticipantSignStatus: DocumentParticipantSignStatus
});

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [[
      {
        TAG: /* Module */ 0,
        _0: [[
            {
              TAG: /* Module */ 0,
              _0: [
                [
                  /* Function */ 0,
                  "name"
                ],
                [
                  /* Function */ 0,
                  "to_int"
                ],
                [
                  /* Function */ 0,
                  "from_int"
                ],
                [
                  /* Function */ 0,
                  "from_int_exn"
                ],
                [
                  /* Function */ 0,
                  "to_string"
                ],
                [
                  /* Function */ 0,
                  "from_string_exn"
                ]
              ]
            },
            "DocumentParticipantSignStatus"
          ]]
      },
      "V1"
    ]]
}, $$Document, {
  V1: V1
});

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [[
      {
        TAG: /* Module */ 0,
        _0: [[
            {
              TAG: /* Module */ 0,
              _0: [[
                  {
                    TAG: /* Module */ 0,
                    _0: [
                      [
                        /* Function */ 0,
                        "name"
                      ],
                      [
                        /* Function */ 0,
                        "to_int"
                      ],
                      [
                        /* Function */ 0,
                        "from_int"
                      ],
                      [
                        /* Function */ 0,
                        "from_int_exn"
                      ],
                      [
                        /* Function */ 0,
                        "to_string"
                      ],
                      [
                        /* Function */ 0,
                        "from_string_exn"
                      ]
                    ]
                  },
                  "DocumentParticipantSignStatus"
                ]]
            },
            "V1"
          ]]
      },
      "$$Document"
    ]]
}, Buhta, {
  $$Document: $$Document
});

export {
  Imported$pmodules,
  Buhta,
}
/* Buhta Not a pure module */
